module.exports = __webpack_public_path__ + "static/media/core4.ec2519db.jpeg";